"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconTransmissionTower = function IconTransmissionTower(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M19.4 7h9.2l.99 5h2.04l-1.39-7H17.76l-1.39 7h2.04zM10 11v-1h1V9h-1V8H8v1H7v1h1v1H7v1h1v3l7.154 3.098L13.779 25H10v-1h1v-1h-1v-1h1v-1h-1v-1H8v1H7v1h1v1H7v1h1v3h32v-3h1v-1h-1v-1h1v-1h-1v-1h-2v1h-1v1h1v1h-1v1h1v1h-3.779l-1.375-6.902L40 15v-3h1v-1h-1v-1h1V9h-1V8h-2v1h-1v1h1v1h-1v1h1v1H10v-1h1v-1zm5.771 4H10.52l4.834 2.097zm1.984.281.056-.281H30.19l.055.28.334 1.72H17.422zm14.892 1.816L32.229 15h5.251zM16 24.32l1.049-5.401 5.705 2.47zM17.434 18 24 20.849 30.566 18zm-.525 7L24 21.93 31.09 25zm14.042-6.081-5.705 2.47L32 24.32zM25 42H4.5v-1h6.102l2.588-13h2.03l-2.581 13H25zm2 0h3v-1h-3zm14.5 0H32v-1h3.361L32.78 28h2.03l2.588 13H41.5z",
    clipRule: "evenodd"
  })));
};

export { IconTransmissionTower, IconTransmissionTower as default };
